import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import GeneralInfoList from "./GeneralInfo/GeneralInfoList";
import ReviewSource from "./GeneralInfo/ReviewSource";
import TaskServiceTable from "./GeneralInfo/TaskServiceTable";
import { useSelector } from "react-redux";
import NoPermissionPage from "../../../components/common/NoPermissionPage";
import GeneralLeadNotification from "./GeneralInfo/LeadNotification/GeneralLeadNotification";

const CustomTabs = styled(Tabs)({
  borderBottom: "1px solid #ddd",
  minHeight: "40px",
});

const CustomTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 500,
  minHeight: "40px",
  padding: "8px 20px",
  border: "1px solid #ddd",
  borderBottom: "none",
  background: "#f5f5f5",
  marginRight: "4px",
  borderTopLeftRadius: "6px",
  borderTopRightRadius: "6px",

  "&.Mui-selected": {
    background: "#008e72",
    color: "#fff",
    fontWeight: 600,
  },
}));

const GeneralInfo = () => {
  const [value, setValue] = useState(0);
  const { user,permissions } = useSelector((state: any) => state?.user);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <section>
      <CustomTabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ style: { display: "none" } }}
      >
        <CustomTab label="General Info" />
        <CustomTab label="Review Source" />
        <CustomTab label="Tasks & Services" />
        <CustomTab label="Lead Notification" />
      </CustomTabs>

      <Box
        sx={{ padding: "16px", border: "1px solid #ddd", borderTop: "none" }}
      >
        {value === 0 && (
          <>
            {user?.user?.roles?.includes("Owner") ||
                user?.user?.roles?.includes("TENANT") ||
                permissions?.["Setting:Sales"]?.read ? (
              <GeneralInfoList />
            ) : (
              <NoPermissionPage />
            )}
          </>
        )}
        {value === 1 && (
          <>
            {user?.user?.roles?.includes("Owner") ||
                user?.user?.roles?.includes("TENANT") ||
                permissions?.["Setting"]?.read ? (
              <ReviewSource />
            ) : (
              <NoPermissionPage />
            )}
          </>
        )}
        {value === 2 && <TaskServiceTable />}
        {value === 3 && <GeneralLeadNotification />}
      </Box>
    </section>
  );
};

export default GeneralInfo;
